"use strict";
exports.__esModule = true;
exports.darkPalette = void 0;
var Colors_1 = require("../_generated/Colors");
exports.darkPalette = {
    type: "dark",
    semantic: {
        colorBackground: Colors_1.ColorBackgroundDark,
        colorBackgroundSecondary: Colors_1.ColorBackgroundSecondaryDark,
        colorBackgroundLeftRail: Colors_1.ColorBackgroundLeftRailDark,
        colorBackgroundInverse: Colors_1.ColorBackgroundInverseDark,
        colorBackgroundGray: Colors_1.ColorBackgroundGrayDark,
        colorBackgroundDisabled: Colors_1.ColorBackgroundDisabledDark,
        colorBackgroundCanvas: Colors_1.ColorBackgroundCanvasDark,
        colorBackgroundHigh: Colors_1.ColorBackgroundHighlightDark,
        colorBackgroundEdit: Colors_1.ColorBackgroundEditDark,
        colorBackgroundRaised: Colors_1.ColorBackgroundRaisedDark,
        colorBackgroundGrayEmp: Colors_1.ColorBackgroundGrayEmpDark,
        colorHover: Colors_1.ColorHoverDark,
        colorCurtain: Colors_1.ColorCurtainDark,
        colorBorder: Colors_1.ColorBorderDark,
        colorBorderDisabled: Colors_1.ColorBorderDisabledDark,
        colorBorderGrid: Colors_1.ColorBorderGridDark,
        colorBorderDeEmp: Colors_1.ColorBorderDeEmpDark,
        colorSelection: Colors_1.ColorSelectionDark,
        colorLogo: Colors_1.ColorLogoDark,
        colorForeground: Colors_1.ColorForegroundDark,
        colorForegroundEmp: Colors_1.ColorForegroundEmpDark,
        colorForegroundDeEmp: Colors_1.ColorForegroundDeEmpDark,
        colorForegroundDisable: Colors_1.ColorForegroundDisableDark,
        colorForegroundInverse: Colors_1.ColorForegroundInverseDark,
        colorForegroundHigh: Colors_1.ColorForegroundHighlightDark,
        colorForegroundHighSelected: Colors_1.ColorForegroundHighlightSelectedDark,
        colorForegroundHighSelectedHover: Colors_1.ColorForegroundHighlightSelectedHoverDark,
        colorForegroundLink: Colors_1.ColorForegroundLinkDark,
        colorForegroundLinkDisabled: Colors_1.ColorForegroundLinkDisabledDark,
        colorForegroundLinkPressed: Colors_1.ColorForegroundLinkPressedDark,
        colorForegroundInvDeEmp: Colors_1.ColorForegroundInvDeEmpDark,
        colorPrimary: Colors_1.ColorPrimaryDark,
        colorPrimaryLighter: Colors_1.ColorPrimaryLighterDark,
        colorPrimaryDarker: Colors_1.ColorPrimaryDarkerDark,
        colorPrimaryHover: Colors_1.ColorPrimaryHoverDark,
        colorPrimaryFocused: Colors_1.ColorPrimaryFocusedDark,
        colorPrimaryPressed: Colors_1.ColorPrimaryPressedDark,
        colorSecondaryFocused: Colors_1.ColorSecondaryFocusedDark,
        colorSecondaryPressed: Colors_1.ColorSecondaryPressedDark,
        colorChipDefaultBackground: Colors_1.ColorChipDefaultBackgroundDark,
        colorChipErrorBackground: Colors_1.ColorChipErrorBackgroundDark,
        colorChipWarningBackground: Colors_1.ColorChipWarningBackgroundDark,
        colorChipInfoBackground: Colors_1.ColorChipInfoBackgroundDark,
        colorChipSuccessBackground: Colors_1.ColorChipSuccessBackgroundDark,
        colorErrorIcon: Colors_1.ColorErrorIconDark,
        colorErrorText: Colors_1.ColorErrorTextDark,
        colorErrorBackground: Colors_1.ColorErrorBackgroundDark,
        colorErrorForegroundInverse: Colors_1.ColorErrorForegroundInverseDark,
        colorInfoForeground: Colors_1.ColorInfoForegroundDark,
        colorInfoForegroundInverse: Colors_1.ColorInfoForegroundInverseDark,
        colorInfoBackground: Colors_1.ColorInfoBackgroundDark,
        colorSuccessIcon: Colors_1.ColorSuccessIconDark,
        colorSuccessText: Colors_1.ColorSuccessTextDark,
        colorSuccessBackground: Colors_1.ColorSuccessBackgroundDark,
        colorSuccessForegroundInverse: Colors_1.ColorSuccessForegroundInverseDark,
        colorWarningIcon: Colors_1.ColorWarningIconDark,
        colorWarningText: Colors_1.ColorWarningTextDark,
        colorWarningBackground: Colors_1.ColorWarningBackgroundDark,
        colorWarningForegroundInverse: Colors_1.ColorWarningForegroundInverseDark,
        colorIconDefault: Colors_1.ColorIconDefaultDark,
        colorIconHover: Colors_1.ColorIconHoverDark,
        colorIconInvertedDefault: Colors_1.ColorIconInvertedDefaultDark,
        colorIconInvertedHover: Colors_1.ColorIconInvertedHoverDark,
        colorToggleOffHover: Colors_1.ColorToggleOffHoverDark,
        colorToggleOffPressed: Colors_1.ColorToggleOffPressedDark,
        colorCalloutBackground: Colors_1.ColorCalloutBackgroundDark,
        colorTileBackground: Colors_1.ColorTileBackgroundDark,
        colorForegroundLight: Colors_1.ColorForegroundLightDark
    },
    primary: {
        contrastText: Colors_1.ColorWhite,
        light: Colors_1.ColorPrimaryLighterLight,
        main: Colors_1.ColorPrimaryDark,
        dark: Colors_1.ColorPrimaryLighterDark
    },
    secondary: {
        contrastText: Colors_1.ColorWhite,
        light: Colors_1.ColorPrimaryLighterLight,
        main: Colors_1.ColorPrimaryDark,
        dark: Colors_1.ColorPrimaryLighterDark
    },
    error: {
        contrastText: Colors_1.ColorWhite,
        light: Colors_1.ColorError250,
        main: Colors_1.ColorError500,
        dark: Colors_1.ColorError750
    },
    success: {
        contrastText: Colors_1.ColorWhite,
        light: Colors_1.ColorGreen250,
        main: Colors_1.ColorGreen500,
        dark: Colors_1.ColorGreen750
    },
    warning: {
        contrastText: Colors_1.ColorWhite,
        light: Colors_1.ColorWarning300,
        main: Colors_1.ColorWarning500,
        dark: Colors_1.ColorWarning700
    },
    info: {
        contrastText: Colors_1.ColorBlack,
        light: Colors_1.ColorInfoBackgroundDark,
        main: Colors_1.ColorInfoForegroundDark,
        dark: Colors_1.ColorInfo700
    },
    orange: {
        100: Colors_1.ColorOrange100,
        200: Colors_1.ColorOrange200,
        300: Colors_1.ColorOrange300,
        400: Colors_1.ColorOrange400,
        500: Colors_1.ColorOrange500,
        600: Colors_1.ColorOrange600,
        700: Colors_1.ColorOrange700,
        800: Colors_1.ColorOrange800
    },
    blue: {
        100: Colors_1.ColorBlue100,
        200: Colors_1.ColorBlue200,
        300: Colors_1.ColorBlue300,
        400: Colors_1.ColorBlue400,
        500: Colors_1.ColorBlue500,
        600: Colors_1.ColorBlue600,
        700: Colors_1.ColorBlue700,
        800: Colors_1.ColorBlue800
    },
    blue_secondary: {
        100: Colors_1.ColorBlueSecondary100,
        200: Colors_1.ColorBlueSecondary200,
        300: Colors_1.ColorBlueSecondary300,
        400: Colors_1.ColorBlueSecondary400,
        500: Colors_1.ColorBlueSecondary500,
        600: Colors_1.ColorBlueSecondary600,
        700: Colors_1.ColorBlueSecondary700,
        800: Colors_1.ColorBlueSecondary800
    },
    green: {
        100: Colors_1.ColorGreen100,
        200: Colors_1.ColorGreen200,
        300: Colors_1.ColorGreen300,
        400: Colors_1.ColorGreen400,
        500: Colors_1.ColorGreen500,
        600: Colors_1.ColorGreen600,
        700: Colors_1.ColorGreen700,
        800: Colors_1.ColorGreen800
    },
    yellow: {
        100: Colors_1.ColorYellow100,
        200: Colors_1.ColorYellow200,
        300: Colors_1.ColorYellow300,
        400: Colors_1.ColorYellow400,
        500: Colors_1.ColorYellow500,
        600: Colors_1.ColorYellow600,
        700: Colors_1.ColorYellow700,
        800: Colors_1.ColorYellow800
    },
    red: {
        100: Colors_1.ColorRed100,
        200: Colors_1.ColorRed200,
        300: Colors_1.ColorRed300,
        400: Colors_1.ColorRed400,
        500: Colors_1.ColorRed500,
        600: Colors_1.ColorRed600,
        700: Colors_1.ColorRed700,
        800: Colors_1.ColorRed800
    },
    purple: {
        100: Colors_1.ColorPurple100,
        200: Colors_1.ColorPurple200,
        300: Colors_1.ColorPurple300,
        400: Colors_1.ColorPurple400,
        500: Colors_1.ColorPurple500,
        600: Colors_1.ColorPurple600,
        700: Colors_1.ColorPurple700,
        800: Colors_1.ColorPurple800
    },
    light_blue: {
        100: Colors_1.ColorLightBlue100,
        200: Colors_1.ColorLightBlue200,
        300: Colors_1.ColorLightBlue300,
        400: Colors_1.ColorLightBlue400,
        500: Colors_1.ColorLightBlue500,
        600: Colors_1.ColorLightBlue600,
        700: Colors_1.ColorLightBlue700,
        800: Colors_1.ColorLightBlue800
    },
    ink: {
        100: Colors_1.ColorInk100,
        150: Colors_1.ColorInk150,
        300: Colors_1.ColorInk300,
        400: Colors_1.ColorInk400,
        450: Colors_1.ColorInk450,
        550: Colors_1.ColorInk550,
        600: Colors_1.ColorInk600,
        650: Colors_1.ColorInk650,
        700: Colors_1.ColorInk700
    },
    text: {
        primary: Colors_1.ColorForegroundDark,
        secondary: Colors_1.ColorForegroundDeEmpDark,
        disabled: Colors_1.ColorForegroundDisableDark
    },
    divider: Colors_1.ColorBorderDark,
    common: {
        black: Colors_1.ColorBlack,
        white: Colors_1.ColorWhite
    },
    icon: Colors_1.ColorIconDefaultDark,
    background: {
        "default": Colors_1.ColorBackgroundDark,
        paper: Colors_1.ColorBackgroundDark
    }
};
